import { createContext } from 'react'

export const ThemeContext = createContext(null)
export const AuthContext = createContext(null)